import {request} from './request';
import * as PATHS from '@/constants/path';

export function fetchSalesInfluencersList() {
  return request(PATHS.FETCH_SALES_INFLUENCERS, { method: 'GET' });
}
